import { IApplicationState } from '../../types/redux';

export const selectIsLocationModalOpen = (state: IApplicationState): boolean => state.locationModal.isOpen;
